module.exports = __webpack_public_path__ + "assets/b82.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b82.png
// module id = 674
// module chunks = 0